import { fetchNext, reportEvent } from '../services/api'
import { actions as appActions } from './app'
import { actions as resultActions } from './result'
import { waitToNext } from '../utils/utils'

const stageZeroSelectMap = {
  0: 1,
  1: -1,
  2: 0
}

const rightAudioPlayer = document.createElement('audio')
rightAudioPlayer.setAttribute('crossOrigin', 'anonymous')
rightAudioPlayer.src = 'https://7n.bczcdn.com/vocabulary/vocabulary_right3.mp3'
rightAudioPlayer.load()
const wrongAudioPlayer = document.createElement('audio')
wrongAudioPlayer.setAttribute('crossOrigin', 'anonymous')
wrongAudioPlayer.src = 'https://7n.bczcdn.com/vocabulary/vocabulary_wrong4.mp3'
wrongAudioPlayer.load()
const commonAudioPlayer = document.createElement('audio')
commonAudioPlayer.setAttribute('crossOrigin', 'anonymous')
commonAudioPlayer.src =
  'https://7n.bczcdn.com/vocabulary/vocabulary_common4.mp3'
commonAudioPlayer.load()

document.body.appendChild(rightAudioPlayer)
document.body.appendChild(wrongAudioPlayer)
document.body.appendChild(commonAudioPlayer)

function getBackendIndex(stage, selectedIndex, rightIndex, beginTime) {
  if (stage === 0) return stageZeroSelectMap[selectedIndex]
  if (new Date() - beginTime - 7500 >= 0) {
    // 超时的时候，返回 -1
    return -1
  }
  if (selectedIndex === rightIndex) return 1
  if (selectedIndex === 5) return 0
  return -1
}

function checkPreTestVeriy(stage, runtime, preHistory) {
  if (stage === 0) return
  if (Math.random() > 0.75) return null
  if (preHistory.length === 0) return null
  const randIdx = parseInt(Math.random() * preHistory.length)
  const preTestWord = preHistory[randIdx]
  if (
    preTestWord.score < runtime.score &&
    preTestWord.selectedIndex === 1 &&
    preTestWord.verified === false
  ) {
    preTestWord.verified = true
    return preTestWord.word
  }
  return null
}

const types = {
  SET_UPLOAD: 'SET_UPLOAD',
  SET_TEST_DATA: 'SET_TEST_DATA',
  SET_TOTAL_COUNT: 'SET_TOTAL_COUNT',
  SET_SHOW_ANSWER: 'SET_SHOW_ANSWER',
  SET_COUNT: 'SET_COUNT',
  START_CUR_TEST: 'START_CUR_TEST',
  STOP_CUR_TEST: 'STOP_CUR_TEST'
}

export const actions = {
  setUpload(status) {
    return { type: types.SET_UPLOAD, payload: status }
  },
  setTestData(data) {
    return { type: types.SET_TEST_DATA, payload: data }
  },
  setCount(count) {
    return { type: types.SET_COUNT, payload: count }
  },
  setTotalCount(count) {
    return { type: types.SET_TOTAL_COUNT, payload: count }
  },
  setShowAnswer(status) {
    return { type: types.SET_SHOW_ANSWER, payload: status }
  },
  startCurTest(timestamp) {
    return { type: types.START_CUR_TEST, payload: timestamp }
  },
  stopCurTest(timestamp) {
    return { type: types.STOP_CUR_TEST, payload: timestamp }
  },
  goNext(selectedIndex, rightIndex) {
    return async (dispatch, getState) => {
      const {
        app: { stage, token },
        test: {
          curWord,
          count,
          runtime,
          totalCount,
          nextWord,
          preHistory,
          beginTime,
          showAnwser
        }
      } = getState()
      let currCount = count + 1
      let currTotalCount = totalCount
      dispatch(this.setCount(currCount))
      dispatch(this.stopCurTest(+new Date())) // 停止当前测试
      dispatch(this.setUpload(true))
      // 上报用户选择的结果
      if (stage === 1) {
        try {
          const {
            app: { testType }
          } = getState()
          const reportContent = {
            stat_group: 'vocabulary-common',
            event_id: 'vocabulary_record',
            extra_info: JSON.stringify({
              type: testType === 2 ? 'listening' : 'reading',
              word: curWord.word,
              result:
                selectedIndex === 5
                  ? 'not_know'
                  : selectedIndex === rightIndex
                  ? 'right'
                  : 'wrong',
              token: token,
              index: count
            })
          }
          reportEvent(reportContent)
        } catch (e) {
          console.error(e, '上报选择错误')
        }
      }

      if (stage === 1 && showAnwser && selectedIndex !== 5) {
        // 正式测试阶段，播放正确与否的音频
        if (selectedIndex === rightIndex) {
          rightAudioPlayer.play()
        } else {
          wrongAudioPlayer.play()
        }
      } else {
        commonAudioPlayer.play()
      }

      if (stage === 0) {
        // 预测阶段，超过 5 道题之后根据正确率动态调整数量
        if (
          currCount >= 5 &&
          runtime.won / currCount > 0.75 &&
          currCount <= 12
        ) {
          if (Math.random() < 0.7) {
            currTotalCount++
            dispatch(this.setTotalCount(currTotalCount))
          }
        }
      } else {
        // 正式测试阶段
        if (currCount >= 10 && currCount <= 25) {
          const rate = runtime.won / currCount
          if ((rate < 0.28 && runtime.score > 3000) || rate > 0.75) {
            currTotalCount++
            dispatch(this.setTotalCount(currTotalCount))
          }
        }
      }

      if (stage === 0) {
        // 预备测试阶段，保存当前的历史数据, 如果超过了最大训练数量，则进入正式测试
        const curStatus = {
          word: curWord.word,
          score: runtime.score,
          verified: false,
          selectedIndex: stageZeroSelectMap[selectedIndex]
        }
        preHistory.push(curStatus)

        if (currCount >= currTotalCount) {
          // 预测阶段只需要进行自动进入正式测试阶段
          dispatch(appActions.createTest())
          // 返回，不在进行请求
          return
        }
      }

      const params = {
        token,
        stage,
        request_word: checkPreTestVeriy(stage, runtime, preHistory),
        answers: [
          {
            index: count,
            word: curWord.word,
            is_verify: curWord.is_verify,
            selected: getBackendIndex(
              stage,
              selectedIndex,
              rightIndex,
              beginTime
            ),
            parallel: curWord.parallel
          }
        ]
      }
      // eslint-disable-next-line
      while (true) {
        try {
          // eslint-disable-next-line
          const [_, data] = await Promise.all([waitToNext(), fetchNext(params)])
          // const data = await fetchNext(params)
          const { questions, runtime } = data
          dispatch(this.setUpload(false))
          dispatch(
            this.setTestData({
              preWord: curWord,
              curWord: nextWord,
              nextWord: questions[0],
              runtime
            })
          )

          // 完成了测试
          if (currCount >= currTotalCount && stage == 1 && currCount >= 60) {
            dispatch(appActions.changeStage(2))
            dispatch(resultActions.fetchAdData())
          }
          dispatch(this.startCurTest(+new Date()))
          break
        } catch (err) {
          console.log(err)
          if (!confirm(err.message + '，确认重试？')) break
        }
      }
    }
  }
}

const initialState = {
  isUpload: false, // 是否正在上传答案
  curWord: null, // 当前这个单词的信息
  preWord: null, // 上一个单词的信息
  nextWord: null, // 下一个单词的信息
  runtime: null, // 当前的做题状态
  count: 0, // 当前轮数
  totalCount: 8, // 测试总次数，这个值会跟着用户正确错误率而发生变化
  showAnwser: true, // 是否显示用户正确错误状态
  preHistory: [], // 用来保存预测阶段的数据，因为正式测试会随机获取之前预的数据进行检验
  playingTimer: false, // 是否开始计时器
  beginTime: 0, // 每道题开始的时间戳
  endTime: 0 // 每道题选择结束的时候的时间戳
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_UPLOAD:
      return {
        ...state,
        isUpload: action.payload
      }
    case types.SET_TEST_DATA:
      return {
        ...state,
        ...action.payload
      }
    case types.SET_COUNT:
      return {
        ...state,
        count: action.payload
      }
    case types.SET_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.payload
      }
    case types.SET_SHOW_ANSWER:
      return {
        ...state,
        showAnwser: action.payload
      }
    case types.START_CUR_TEST:
      return {
        ...state,
        playingTimer: true,
        beginTime: action.payload
      }
    case types.STOP_CUR_TEST:
      return {
        ...state,
        playingTimer: false,
        endTime: action.payload
      }
    default:
      return state
  }
}
